import { render, staticRenderFns } from "./ModalContentCity.vue?vue&type=template&id=263c6770&"
import script from "./ModalContentCity.vue?vue&type=script&lang=js&"
export * from "./ModalContentCity.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentCity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSimpleCheckbox,VSkeletonLoader})
